import { ValidationFailure } from '../types/ValidationFailure';
import { ValidationResult } from '../types/ValidationResult';

export const createValidationResultFromFailures = (failures: ValidationFailure[]): ValidationResult => ({
  isValid: !failures.length,
  failures,
});
